export default __webpack_public_path__ + "static/media/camera-icon.271471c6.svg";